import type { Entity } from '@backstage/catalog-model';
import {
  kratixNamespace,
  KratixType,
  WithKratixAnnotations,
} from '../types/kratix';

export function isKratixType(type: KratixType) {
  return (entity: Entity) => {
    const maybeKratix = (entity.metadata.annotations ?? {}) as WithKratixAnnotations;
    return maybeKratix['kratix.io/type'] === type;
  };
}

export function isKratixEntity() {
  return (entity: Entity) => {
    const kratixAnnotations = (entity.metadata.annotations ?? {}) as WithKratixAnnotations;
    return Object.keys(kratixAnnotations).some(key =>
      key.includes(kratixNamespace),
    );
  };
}

export function getKratixTemplateName(entity: Entity) {
  const kratixAnnotations = (entity.metadata.annotations ?? {}) as WithKratixAnnotations;
  return kratixAnnotations['kratix.io/backstage-promise-template'];
}

export function getPromiseEntity(entity: Entity): Entity {
  const kratixAnnotations = (entity.metadata.annotations ?? {}) as WithKratixAnnotations;

  return {
    apiVersion: `${kratixAnnotations['kratix.io/group']}/${kratixAnnotations['kratix.io/version']}`,
    kind: kratixAnnotations['kratix.io/kind'],
    metadata: {
      name: kratixAnnotations['kratix.io/name'],
      namespace: kratixAnnotations['kratix.io/namespace'],
    },
  };
}
